import {RsnLogoSpinner} from '@raison/ui-kit';
import * as Sentry from '@sentry/react';
import React, {useEffect} from 'react';

export function LoadingScreen() {
    useEffect(() => {
        let sent = false;
        const timeoutId = setTimeout(sendWarning, 1000);
        const mountTs = Date.now();

        return () => {
            clearTimeout(timeoutId);
            sendWarning();
        };

        function sendWarning() {
            if (sent) {
                return;
            }
            sent = true;
            Sentry.captureException(new Error('Poor loading state UX. Showing fallback LoadingScreen'), {
                level: 'warning',
                extra: {
                    'Time on screen': `${(Date.now() - mountTs) * 0.001}s`,
                },
            });
        }
    }, []);

    return (
        <div className='absolute inset-0 grid place-items-center'>
            <RsnLogoSpinner size={'80'} />
        </div>
    );
}
